import { Space, Table } from 'antd'
import { Roster } from 'types/roster'
import { ColumnsType } from 'antd/es/table'
import { memo, useMemo } from 'react'

type Props = {
    rosters: Roster[]
    editRoster: (rosterId: number) => void
}

export const RosterTable = memo((props: Props) => {
    const { rosters, editRoster } = props

    const columns: ColumnsType<Roster> = useMemo(
        () => [
            {
                title: 'ID',
                dataIndex: 'id',
                key: 'id',
            },
            {
                title: 'Player',
                key: 'playerId',
                render: (_, record) => `${record.player?.name} ${record.player?.surname}`,
            },
            {
                title: 'G',
                dataIndex: 'count_goals',
                key: 'count_goals',
            },
            {
                title: 'GP',
                dataIndex: 'count_goal_passes',
                key: 'count_goal_passes',
            },
            {
                title: 'OG',
                dataIndex: 'count_own_goals',
                key: 'count_own_goals',
            },
            {
                title: 'YC',
                dataIndex: 'yellow_card',
                key: 'yellow_card',
            },
            {
                title: 'RC',
                dataIndex: 'red_card',
                key: 'red_card',
            },
            {
                title: 'MVP',
                key: 'mvp',
                render: (_, record) => (record.mvp === 1 ? 'MVP' : ''),
            },
            {
                title: 'Action',
                key: 'action',
                render: (_, record) => (
                    <Space size='middle'>
                        <a onClick={() => editRoster(record.id)}>Edit</a>
                        {/*<Popconfirm*/}
                        {/*    title={'Delete the team'}*/}
                        {/*    description={'Are you sure to delete this team?'}*/}
                        {/*    onConfirm={() => onDelete(record.id)}*/}
                        {/*    okText={'Yes'}*/}
                        {/*    cancelText={'No'}*/}
                        {/*>*/}
                        {/*    <a href='#'>Delete</a>*/}
                        {/*</Popconfirm>*/}
                    </Space>
                ),
            },
        ],
        [editRoster]
    )

    return <Table pagination={false} columns={columns} dataSource={rosters} rowKey={'id'} />
})
